import { render, staticRenderFns } from "./PershingMaritalStatus.vue?vue&type=template&id=e8c18d0a&scoped=true"
import script from "./PershingMaritalStatus.vue?vue&type=script&lang=js"
export * from "./PershingMaritalStatus.vue?vue&type=script&lang=js"
import style0 from "./PershingMaritalStatus.vue?vue&type=style&index=0&id=e8c18d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c18d0a",
  null
  
)

export default component.exports